import { render } from "./TaskProgress.vue?vue&type=template&id=a7cc88c6"
import script from "./TaskProgress.vue?vue&type=script&lang=js"
export * from "./TaskProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__